import img1 from "../assests/faceimg.webp";
import img2 from "../assests/faceimg2.webp";
import img3 from "../assests/faceimg.webp";


const WhyCeliora = () => {


const features = [

{
image:img1,
title:"Korean Innovation",
text:"Inspired by Korean beauty rituals with advanced skincare technology."
},

{
image:img2,
title:"Clean Ingredients",
text:"Gentle formulas created with carefully selected natural ingredients."
},

{
image:img3,
title:"Indian Skin Focus",
text:"Developed specially to understand and care for Indian skin."
}

];


return (

<section className="why-section">


<div className="why-container">


<div className="why-header">

<span>
WHY CELIORA
</span>


<h2>
Beauty Inspired
<br/>
By Science
</h2>

<p>
Where Korean innovation meets Indian skincare needs.
</p>

</div>

<div className="why-cards">

{
features.map((item,index)=>(

<div className="why-card" key={index}>


<div className="why-image">

<img src={item.image} />

</div>
<div className="why-content">
<h3>
{item.title}
</h3>

<p>{item.text}</p>
<button>Discover More</button>

</div>

</div>

))
}

</div>
</div>
</section>
)
}

export default WhyCeliora;